import React from 'react'
import { TRUST_SEAL_IMAGE_BASE } from '../../utils/constant'

interface TrustSealNotFoundProps {
    message?: string
}

const TrustSealNotFound: React.FC<TrustSealNotFoundProps> = ({
    message = 'The requested Trust Seal record could not be found. Please check the URL or contact support for help.',
}) => (
    <section id="quotation" style={{ paddingBottom: '50px' }}>
        <div className="container">
            <div className="row">
                <div className="col-md-3" />
                <div className="col-md-6 text-center">
                    <div className="p-t-b-30">
                        <div className="p-b-30">
                            <img src={`${TRUST_SEAL_IMAGE_BASE}/invalid.png`} alt="Not Found" width="80" />
                        </div>
                        <h6 className="head6">Record Not Found</h6>
                        <p className="para" style={{ marginTop: '20px' }}>{message}</p>
                    </div>
                </div>
                <div className="col-md-3" />
            </div>
        </div>
    </section>
)

export default TrustSealNotFound
